import http from "./client";
import { IMailing, IMailingStatistics, TMailingStatus, TMailingType } from "../typings/IMailing";
import { ITransferListFilter } from "../typings/ITransferList";

async function list(courseId: string, search: string, page: number, limit: number) {
  const response = await http.get(`/api/v2/mailings`, {
    params: { course_id: courseId, search, page, limit }
  });

  return response.data;
};

async function get(courseId: string, id: string) {
  const response = await http.get(`/api/v2/mailings/${id}`, {
    params: { course_id: courseId }
  });

  return response.data;
};

const mockCtr: IMailingStatistics = {
  "mailing_id": "0194fddf-1f4c-70f4-beff-3e15f7022993",
  "totalCount": 2,
  "openedTotalCount": 1,
  "openedTotalRatio": 50,
  "notOpenedTotalCount": 1,
  "notOpenedTotalRatio": 50,
  "openedDaysCount": {
    "2025-03-20": {
        "date": "2025-03-20 00:00:00",
        "count": 10
    },
    "2025-03-19": {
        "date": "2025-03-19 00:00:00",
        "count": 20
    },
    "2025-03-18": {
        "date": "2025-03-18 00:00:00",
        "count": 30
    },
    "2025-03-17": {
        "date": "2025-03-17 00:00:00",
        "count": 40
    },
    "2025-03-16": {
        "date": "2025-03-16 00:00:00",
        "count": 50
    },
    "2025-03-15": {
        "date": "2025-03-15 00:00:00",
        "count": 60
    },
    "2025-03-14": {
        "date": "2025-03-14 00:00:00",
        "count": 70
    },
    "2025-03-13": {
        "date": "2025-03-13 00:00:00",
        "count": 80
    }
  },
  "totalLinkFollowCount": 2,
  "totalLinkNotFollowCount": 3,
  "links": [
      {
          "link": "https://efwefwfewef4asdddddddddddddddasdasdasdasdasdasdasdasdasdasdasdasdasdasdasdasdasdasdasdadas.com",
          "linkCount": 2,
          "linkRatio": 100
      },
      {
          "link": "https://efwefwfewef1.com",
          "linkCount": 1,
          "linkRatio": 50
      },
      {
          "link": "http://www.omdrug.ru/information/drugs.php",
          "linkCount": 1,
          "linkRatio": 50
      },
      {
          "link": "https://efwefwfewef7.com",
          "linkCount": 1,
          "linkRatio": 50
      },
      {
          "link": "https://efwefwfewef6.com",
          "linkCount": 1,
          "linkRatio": 50
      },
      {
          "link": "http://efwefwfewef5.com",
          "linkCount": 1,
          "linkRatio": 50
      },
      {
          "link": "link2",
          "linkCount": 1,
          "linkRatio": 50
      },
      {
          "link": "link3",
          "linkCount": 1,
          "linkRatio": 50
      }
  ]
};

async function ctr(courseId: string, id: string): Promise<IMailingStatistics> {
  const response = await http.get(`/api/v2/mailings/${id}/ctr`, {
    params: { course_id: courseId }
  });

  // return mockCtr;
  return response.data;
}

async function create(courseId: string, mailing: IMailing, draft: boolean) {
  const response = await http.post(`/api/v2/mailings`, draft ? { ...mailing, draft: true } : mailing, {
    params: { course_id: courseId }
  });

  return response.data;
};

async function update(courseId: string, mailing: IMailing, draft: boolean) {
  const response = await http.put(`/api/v2/mailings/${mailing.id}`, draft ? { ...mailing, draft: true } : mailing, {
    params: { course_id: courseId }
  });

  return response.data;
};

async function copy(courseId: string, id: string) {
  const response = await http.post(`/api/v2/mailings/${id}/copy`, {}, {
    params: { course_id: courseId }
  });

  return response.data;
};

async function remove(courseId: string, id: string) {
  const response = await http.delete(`/api/v2/mailings/${id}`, {
    params: { course_id: courseId }
  });

  return response.data;
};

async function recipientsList(courseId: string, id: string, search: string, page: number, limit: number) {
  const response = await http.get(`/api/v2/mailings/${id}/recipients`, {
    params: { course_id: courseId, search, page, limit }
  });

  return response.data;
};

async function emailRecipientsLink(courseId: string, id: string, targets: number[]) {
  const response = await http.post(`/api/v2/mailings/${id}/recipients`, {
    targets: targets,
  }, {
    params: {course_id: courseId}
  });

  return response.data;
};

async function emailRecipientsUnlink(courseId: string, id: string, targets: number[]) {
  const response = await http.delete(`/api/v2/mailings/${id}/recipients`, {
    data: { targets: targets },
    params: {course_id: courseId}
  });

  return response.data;
};

async function emailRecipientsLinkAll(courseId: string, id: string, filter?: ITransferListFilter) {
  const response = await http.post(`/api/mailings/link-all`, {
    id: id,
    filter
  }, {
    params: {course_id: courseId}
  });

  return response.data;
};

async function emailRecipientsUnlinkAll(courseId: string, id: string) {
  const response = await http.post(`/api/mailings/unlink-all`, {
    id: id,
  }, {
    params: {course_id: courseId}
  });

  return response.data;
};

async function personalChatRecipientsLink(courseId: string, id: string, targets: number[]) {
  const response = await http.post(`/api/v2/mailings/${id}/chat/user/recipients`, {
    targets: targets,
  }, {
    params: {course_id: courseId}
  });

  return response.data;
};

async function personalChatRecipientsUnlink(courseId: string, id: string, targets: number[]) {
  const response = await http.delete(`/api/v2/mailings/${id}/chat/user/recipients`, {
    data: { targets: targets },
    params: {course_id: courseId}
  });

  return response.data;
};

async function personalChatRecipientsLinkAll(courseId: string, id: string, filter?: ITransferListFilter) {
  const response = await http.post(`/api/mailings/link-all-chatuser`, {
    id: id,
    filter
  }, {
    params: {coruse_id: courseId}
  });

  return response.data;
};

async function personalChatRecipientsUnlinkAll(courseId: string, id: string) {
  const response = await http.post(`/api/mailings/unlink-all-chatuser`, {
    id: id,
  }, {
    params: {course_id: courseId}
  });

  return response.data;
};

async function groupChatRecipientsLink(courseId: string, id: string, targets: number[]) {
  const response = await http.post(`/api/v2/mailings/${id}/chat/room/recipients`, {
    targets: targets,
  }, {
    params: {course_id: courseId}
  });

  return response.data;
};

async function groupChatRecipientsUnlink(courseId: string, id: string, targets: number[]) {
  const response = await http.delete(`/api/v2/mailings/${id}/chat/room/recipients`, {
    data: { targets: targets },
    params: {course_id: courseId}
  });

  return response.data;
};

async function groupChatRecipientsLinkAll(courseId: string, id: string) {
  const response = await http.post(`/api/mailings/link-all-chatroom`, {
    id: id,
  }, {
    params: {coruse_id: courseId}
  });

  return response.data;
};

async function groupChatRecipientsUnlinkAll(courseId: string, id: string) {
  const response = await http.post(`/api/mailings/unlink-all-chatroom`, {
    id: id,
  }, {
    params: {course_id: courseId}
  });

  return response.data;
};

const mailings = {
  list,
  get,
  ctr,
  create,
  update,
  copy,
  remove,
  recipientsList,
  emailRecipientsLink,
  emailRecipientsUnlink,
  emailRecipientsLinkAll,
  emailRecipientsUnlinkAll,
  personalChatRecipientsLink,
  personalChatRecipientsUnlink,
  personalChatRecipientsLinkAll,
  personalChatRecipientsUnlinkAll,
  groupChatRecipientsLink,
  groupChatRecipientsUnlink,
  groupChatRecipientsLinkAll,
  groupChatRecipientsUnlinkAll
};

export default mailings;